import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "sh-box",
  role: "dialog",
  "aria-label": "Atalhos de teclado"
}
const _hoisted_2 = { class: "sh-body" }
const _hoisted_3 = { class: "sh-section" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = { class: "sh-rows" }
const _hoisted_6 = { class: "sh-row" }
const _hoisted_7 = {
  key: 0,
  class: "sh-row"
}
const _hoisted_8 = {
  key: 1,
  class: "sh-row"
}
const _hoisted_9 = { class: "sh-section" }
const _hoisted_10 = ["aria-expanded"]
const _hoisted_11 = { class: "sh-rows" }
const _hoisted_12 = { class: "sh-section" }
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = { class: "sh-rows" }

import { computed, ref } from 'vue'
import { shortcutsHelpOpen, closeShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useAdmin } from '@/composables/useAdmin'
import { usePermission } from '@/composables/usePermission'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShortcutsHelp',
  setup(__props) {

const open  = shortcutsHelpOpen
const { globalSettings } = useAdmin()
// Reflete a chave "Envio de Aviso Interno" de Configurações Gerais (kill-switch
// geral, independente de perfil) — não a permissão broadcast.send em si, que
// segue controlando se o atalho de fato funciona pra este usuário.
const broadcastEnabled = computed(() => globalSettings.value.broadcastEnabled)

// Espelho ao vivo (Ctrl+@): só aparece pra quem pode usar (permissão agents.screen_view).
const { can } = usePermission()
const canMirror = computed(() => can('agents.screen_view'))
// Sessões dos agentes (Ctrl+Shift+S): permissão sessions.manage (perfil Sistema).
const canManageSessions = computed(() => can('sessions.manage'))
function close() { closeShortcutsHelp() }

// Categorias recolhidas (todas abertas por padrão).
const collapsed = ref(new Set<string>())
function toggle(key: string) {
  const next = new Set(collapsed.value)
  if (next.has(key)) next.delete(key)
  else next.add(key)
  collapsed.value = next
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "sh-fade" }, {
      default: _withCtx(() => [
        (_unref(open))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sh-overlay",
              onMousedown: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", { class: "sh-header" }, [
                  _cache[4] || (_cache[4] = _createElementVNode("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "7",
                      width: "20",
                      height: "14",
                      rx: "2",
                      ry: "2"
                    }),
                    _createElementVNode("path", { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" })
                  ], -1)),
                  _cache[5] || (_cache[5] = _createTextVNode(" Atalhos de Teclado ", -1)),
                  _createElementVNode("button", {
                    class: "sh-close",
                    onClick: close
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "sh-section-title",
                      "aria-expanded": !collapsed.value.has('geral'),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle('geral')))
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["sh-chevron", { 'sh-chevron--open': !collapsed.value.has('geral') }]),
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("path", { d: "m9 6 6 6-6 6" }, null, -1)
                      ]))], 2)),
                      _cache[7] || (_cache[7] = _createTextVNode(" Geral ", -1))
                    ], 8, _hoisted_4),
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "/")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Abrir busca global")
                      ], -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "Ctrl"),
                          _createElementVNode("span", { class: "sh-plus" }, "+"),
                          _createElementVNode("kbd", null, "K")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Abrir busca global")
                      ], -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "?")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Ver atalhos")
                      ], -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "Esc")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Fechar janela ativa")
                      ], -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "K")
                        ], -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sh-desc" }, "Enviar aviso para agentes", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["sh-status", broadcastEnabled.value ? 'sh-status--on' : 'sh-status--off'])
                        }, _toDisplayString(broadcastEnabled.value ? 'Habilitado' : 'Desabilitado'), 3)
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "Ctrl"),
                          _createElementVNode("span", { class: "sh-plus" }, "+"),
                          _createElementVNode("kbd", null, "Shift"),
                          _createElementVNode("span", { class: "sh-plus" }, "+"),
                          _createElementVNode("kbd", null, "C")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Conversas: abre, minimiza (ícone no canto inferior esquerdo) e volta. Sem o Google Workspace configurado, abre um exemplo")
                      ], -1)),
                      (canMirror.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("div", { class: "sh-keys" }, [
                              _createElementVNode("kbd", null, "Ctrl"),
                              _createElementVNode("span", { class: "sh-plus" }, "+"),
                              _createElementVNode("kbd", null, "@")
                            ], -1),
                            _createElementVNode("div", { class: "sh-desc" }, "Espelho ao vivo (ver a tela de um agente)", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (canManageSessions.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("div", { class: "sh-keys" }, [
                              _createElementVNode("kbd", null, "Ctrl"),
                              _createElementVNode("span", { class: "sh-plus" }, "+"),
                              _createElementVNode("kbd", null, "Shift"),
                              _createElementVNode("span", { class: "sh-plus" }, "+"),
                              _createElementVNode("kbd", null, "S")
                            ], -1),
                            _createElementVNode("div", { class: "sh-desc" }, "Sessões dos agentes (revogar e deslogar)", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, !collapsed.value.has('geral')]
                    ])
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "sh-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "sh-section-title",
                      "aria-expanded": !collapsed.value.has('conversas'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (toggle('conversas')))
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["sh-chevron", { 'sh-chevron--open': !collapsed.value.has('conversas') }]),
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("path", { d: "m9 6 6 6-6 6" }, null, -1)
                      ]))], 2)),
                      _cache[18] || (_cache[18] = _createTextVNode(" Conversas ", -1))
                    ], 8, _hoisted_10),
                    _withDirectives(_createElementVNode("div", _hoisted_11, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "N")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Próxima conversa na lista")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "P")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Conversa anterior na lista")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "R")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Focar campo de resposta")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "C")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Abrir minhas conversas")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "M")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Abrir Modo Foco")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "Ctrl"),
                          _createElementVNode("span", { class: "sh-plus" }, "+"),
                          _createElementVNode("kbd", null, "↵")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Enviar mensagem")
                      ], -1)
                    ]))], 512), [
                      [_vShow, !collapsed.value.has('conversas')]
                    ])
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "sh-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "sh-section-title",
                      "aria-expanded": !collapsed.value.has('navegacao'),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggle('navegacao')))
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["sh-chevron", { 'sh-chevron--open': !collapsed.value.has('navegacao') }]),
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true"
                      }, [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("path", { d: "m9 6 6 6-6 6" }, null, -1)
                      ]))], 2)),
                      _cache[21] || (_cache[21] = _createTextVNode(" Navegação ", -1))
                    ], 8, _hoisted_13),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "↑"),
                          _createElementVNode("kbd", null, "↓")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Navegar nos resultados da busca")
                      ], -1),
                      _createElementVNode("div", { class: "sh-row" }, [
                        _createElementVNode("div", { class: "sh-keys" }, [
                          _createElementVNode("kbd", null, "↵")
                        ]),
                        _createElementVNode("div", { class: "sh-desc" }, "Abrir item selecionado na busca")
                      ], -1)
                    ]))], 512), [
                      [_vShow, !collapsed.value.has('navegacao')]
                    ])
                  ])
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "sh-footer" }, [
                  _createTextVNode(" Pressione "),
                  _createElementVNode("kbd", null, "?"),
                  _createTextVNode(" a qualquer momento para ver esta tela ")
                ], -1))
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})